// src/Pages/Solutions/SolutionPage.jsx

import React from "react";
import { useParams } from "react-router-dom";
// import SolutionsData from "./solutionsData";
import Solutions from "./solutions";
import "../../Styles/features.css";
import seamlessinterview1 from "../../Assets/images/home/seamless-interview-1.png";
import { useNavigate } from "react-router-dom";

const SolutionPage = () => {
  const { featureSlug } = useParams();
  const data = Solutions[featureSlug];
  const navigate = useNavigate();

  if (!data) return <h2>Feature Not Found</h2>;

  const onclickcontatctus = () => {
    navigate("/contact-us");
    window.scrollTo(0, 0);
  };
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return (
    <div className="features-drop-down-main-app-coontianer">
      <div className="features-dropdown-banner-section">
        <div className="width-wrapper">
          <div className="banner-content-2" data-aos="zoom-in-down">
            <h1>{data.title}</h1>
            <h3>{data.subtitle}</h3>
            <p>{data.description}</p>
          </div>
        </div>
      </div>
      {/* Section 2 */}
      <div className="features-wrapper-2">
        <div className="width-wrapper">
          {data.section2?.map((each, i) => (
            <div className="features-wraper-1" key={i}>
              <div className="wrap-1-card-2" data-aos="zoom-in">
                <div className="f-wrap-content-2">
                  <h1>{each.heading}</h1>
                  <p>{each.text}</p>
                </div>
                <img src={each.image} alt={each.heading} className="d-d" />
                <img src={each.image2} alt={each.heading} className="m-d" />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Section 3 */}
      {/* <div className="features-wrapper-3">
        <div className="width-wrapper">
          {data.section3?.map((each, i) => (
            <div className="features-wraper-1" key={i}>
              <div className="wrap-1-card">
                {i % 2 === 0 ? (
                  <>
                    
                    <div className="f-wrap-content f-wrap-content-2">
                      <h1>{each.heading}</h1>
                      <p>{each.text}</p>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="f-wrap-content">
                      <h1>{each.heading}</h1>
                      <p>{each.text}</p>
                    </div>
                    
                  </>
                )}
              </div>
            </div>
          ))}
        </div>
      </div> */}
      <div
        className="features-wrapper-4"
        style={{ background: "#fff !important" }}
        data-aos="zoom-in-down"
      >
        <div className="width-wrapper">
          <div className="for-employers-wrap ">
            {data.section3?.map((each, i) => (
              <div className="for-employers-1">
                <h1>{each.heading}</h1>
                <p>{each.text}</p>
              </div>
            ))}
          </div>
          {/* {data.section3?.map((each, i) => (
            <div className="features-wraper-1" key={i}>
              <div className="wrap-1-card-2">
                <div
                  className={`f-wrap-content-sol ${
                    i % 2 === 0 ? "f-wrap-content-4" : ""
                  }`}
                >
                  <h1>{each.heading}</h1>
                  <p>{each.text}</p>
                </div>
              </div>
            </div>
          ))} */}
        </div>
      </div>

      {/* Section 4 */}
      {/* <div className="feature-section-4">
        <div className="width-wrapper">
          {data.section4?.map((each, i) => (
            <><div key={i}>
              <h2>{each.heading}</h2>
              <p>{each.text}</p>
              <ul>
                <li>{each.p1}</li>
                <li>{each.p2}</li>
                <li>{each.p3}</li>
              </ul>
            </div><img src={each.image} alt={each.heading} /></>
          ))}
        </div>
      </div> */}

      <div className="chat-detection-wrapper-sol padding-1">
        <div className="width-wrapper">
          {data.section4?.map((each, i) => (
            <div className="seamless-interview-wrap nobg">
              <div
                className="seamless-interview-1 nobg"
                data-aos="fade-right"
                data-aos-delay="200"
              >
                <h2>{each.heading}</h2>
                <p>{each.text}</p>

                {/* <ul>
                <li>
                  <span>Forget Manual </span>
                  <strong>scheduling.</strong>
                </li>

                <li>
                  <span>Ann self-coordinates her </span>
                  <strong>interviews</strong>24/7.
                </li>

                <li>
                  <strong>Reminds</strong> candidates to reduce no-shows.
                </li>

                <li>
                  <span>Meets several candidates </span>
                  <strong>concurrently.</strong>
                </li>
              </ul> */}
                <ul>
                  <li>{each.p1}</li>

                  <li>{each.p2}</li>

                  <li>{each.p3}</li>
                </ul>
              </div>
              <div
                className="seamless-interview-2"
                data-aos="fade-left0"
                data-aos-delay="200"
              >
                {" "}
                <img src={each.image} alt={each.heading} />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Final CTA Section */}
      <div className="feaured-wrapper-3">
        <div className="width-wrapper">
          {data.finalsection?.map((each, i) => (
            <div key={i} className="features-warp-3" data-aos="zoom-in-up">
              <h2>{each.heading}</h2>
              <p>{each.text}</p>
              <button type="button" onClick={onclickcontatctus}>
                {each.button} <span className="arrow">→</span>
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SolutionPage;
